// extracted by mini-css-extract-plugin
export var lg = "_3e-4";
export var md = "_3e-3";
export var sm = "_3e-2";
export var xs = "_3e-1";
export var xxs = "_3e-0";